import script from "./StudentLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentLogin.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./StudentLogin.vue?vue&type=style&index=1&id=625ee2b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-625ee2b4"]])

export default __exports__